
import showToastr from "../../../util/toastr.js";
import * as domainConstants from "../../../constants/DomainConstants";
import voortgangsrapportProjectApi from "../../../api/voortgangsrapportProjectApi";


import redirector from "../../../util/redirector.js";
import { getStore } from "../../../store/configureStore";
import mergeDeep from "../../../util/mergeDeep.js";

export default class VRProjectPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const { loadLayout, setDisabledInputComponents, isNew, vrProjectId, dossierId } = this.context.props;

		if (vrProjectId || dossierId) {
			if (isNew) {
				this.context.props.ajaxStarted();
				voortgangsrapportProjectApi.getEmptyVoortgangsrapport(dossierId).then(response => {
					this.context.props.ajaxEnded();

					const vrProject = response.data;
					const errors = {};

					this.context.setState({
						vrProject,
						errors
					});

					setDisabledInputComponents(vrProject.redenVanStatus == 121450000);
					loadLayout(vrProject.naam, this.context.props.refGemeenten[vrProject.gemeente], vrProject.id, false, vrProject.isEindrapport);
				}).catch(error => {
					this.context.props.ajaxFailed(error);
					this.context.props.throwException(error);
				});
			}
			else {
				this.context.props.ajaxStarted();
				
				voortgangsrapportProjectApi.get(vrProjectId).then(response => {
					this.context.props.beadsLoaded(response.data.item.beadModels);
					this.context.props.ajaxEnded();
					this.context.props.voortgangsrapportLoaded(response.data.hasValidationErrors);

					const vrProject = response.data.item;
					const errors = response.data.validationResults || {};

					this.context.setState({
						vrProject,
						errors
					});

					setDisabledInputComponents(vrProject.redenVanStatus == 121450000);
					loadLayout(vrProject.naam, this.context.props.refGemeenten[vrProject.gemeente], vrProject.id, true, vrProject.isEindrapport);
				}).catch(error => {
					this.context.props.ajaxFailed(error);
					this.context.props.throwException(error);
				});
			}
		}
		else
			redirector.goToNotFound();
	}

	onChange(event) {
		const field = event.target.name;
		const vrProject = this.context.state.vrProject;
		vrProject[field] = event.target.value;

		if (field === "isOmschrijvingProjectGewijzigd" && event.target.value == "false") {
			vrProject["toelichtingWijzigingOmschrijvingProject"] = "";
		}

		return this.context.setState({
			vrProject: vrProject,
			hasUnsavedChanges: true
		});
	}

	onSave() {
		this.context.props.ajaxStarted();

		voortgangsrapportProjectApi.save(this.context.state.vrProject)
			.then((response) => {
				let vrProject = response.data.item;
				this.context.props.ajaxEnded();
				let result = null;
				if (response.data.concurrencyException) {
					this.context.setState({ vrProject, errors: response.data.validationResults });
					result = domainConstants.HAS_CONCURRENCY_EXCEPTION;
				} else if (response.data.hasValidationErrors) {
					this.context.props.voortgangsrapportLoaded(false, response.data.hasValidationErrors);
					this.context.setState({ vrProject, errors: response.data.validationResults});
					result = domainConstants.HAS_VALIDATION_ERRORS;
				} else if (Object.keys(response.data.validationResults).length !== 0) {
					this.context.setState({ vrProject, errors: response.data.validationResults });
					result = domainConstants.HAS_VALIDATION_ERRORS_SAVED;
				} else {
					this.context.setState({ vrProject, errors: null });
					result = domainConstants.SUCCESS;
				}

				let isSaved = showToastr(result);

				if (isSaved) {
					this.context.props.voortgangsrapportLoaded(true, response.data.hasValidationErrors);
					this.context.props.loadLayout(vrProject.naam, this.context.props.refGemeenten[vrProject.gemeente], vrProject.id, true, vrProject.isEindrapport);
					this.context.props.beadsLoaded(response.data.item.beadModels);
					this.context.setState({
						hasUnsavedChanges: false
					});
				}
			}).catch(error => {
				this.context.props.ajaxFailed(error);
				this.context.props.throwException(error);
			});
	}
}